module.exports = new __parcel__URL__("lune-voile-pluie-1.8ae6d3a4.svg").toString();